import React, { useState } from 'react';
import { sendEmailVerification, reload } from 'firebase/auth';
import { auth } from '../firebase';

function Verify({ email, onVerified }) {
  const [checking, setChecking] = useState(false);
  const [resent, setResent] = useState(false);
  const [error, setError] = useState('');

  const checkVerified = async () => {
    setChecking(true);
    setError('');
    try {
      await reload(auth.currentUser);
      if (auth.currentUser.emailVerified) {
        onVerified();
      } else {
        setError('Email not verified yet. Check your inbox and click the link.');
      }
    } catch (e) {
      setError('Something went wrong. Try again.');
    }
    setChecking(false);
  };

  const resendEmail = async () => {
    try {
      await sendEmailVerification(auth.currentUser);
      setResent(true);
      setTimeout(() => setResent(false), 3000);
    } catch (e) {
      setError('Could not resend. Try again later.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-5">
      <div className="bg-gray-900 border border-gray-800 rounded-2xl p-7 w-full max-w-sm text-center">

        <svg width="40" height="40" viewBox="0 0 100 130" fill="none" className="mx-auto mb-4">
          <defs>
            <linearGradient id="vg" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#f2c832"/>
              <stop offset="100%" stopColor="#e8496a"/>
            </linearGradient>
          </defs>
          <path d="M58 4L84 4L84 10L68 10L68 54L84 54L84 62L52 126L42 126L62 72L44 72L44 62L16 62L16 54L32 54L32 10L16 10L16 4L42 4L42 54L58 54Z" fill="url(#vg)"/>
        </svg>

        <div className="bg-green-950 border border-green-800 rounded-xl p-4 mb-5">
          <div className="text-2xl mb-2">✉</div>
          <h2 className="text-sm font-bold text-white mb-1">Check your email</h2>
          <p className="text-xs text-gray-400 leading-relaxed">
            We sent a verification link to<br/>
            <span className="text-white font-medium">{email}</span>
          </p>
        </div>

        {error && (
          <div className="bg-red-950 border border-red-800 rounded-lg px-3 py-2 text-xs text-red-400 mb-4">
            {error}
          </div>
        )}

        {resent && (
          <div className="bg-green-950 border border-green-800 rounded-lg px-3 py-2 text-xs text-green-400 mb-4">
            ✓ Email resent!
          </div>
        )}

        <button
          onClick={checkVerified}
          disabled={checking}
          className="w-full bg-gradient-to-r from-yellow-500 to-pink-600 text-white font-semibold py-2.5 rounded-lg text-sm hover:opacity-90 transition-all disabled:opacity-40 mb-3"
        >
          {checking ? 'Checking...' : "I've verified my email →"}
        </button>

        <button
          onClick={resendEmail}
          className="w-full bg-transparent border border-gray-700 text-gray-400 py-2.5 rounded-lg text-sm hover:border-yellow-500 hover:text-yellow-400 transition-all"
        >
          ↺ Resend email
        </button>

      </div>
    </div>
  );
}

export default Verify;